import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pagination"
export default class extends Controller {
  static targets = ["frame"];

  scrollToFrame(event) {
    const turboFrame = document.querySelector(".paginated-content");
    if (turboFrame) {
      turboFrame.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
